import BaseClass from "./BaseClass";
import Helper from "./Helper";

const defaultOptions = {};

export default class Sort extends BaseClass {

  /**
   * Constructor
   * @param options
   */
    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {
        $(document).ready(function () {
            $('[data-masonrysort]').click(function (event) {
                var sortName = $(this).data('masonrysort');
                var sortWay = $(this).data('sortway');

                $('[data-sortables]').each(function () {
                    var wrapper = $(this);

                    if (sortWay === 'asc') {
                        var sortedList = wrapper.find('[data-sortable]').sort(function (a, b) {
                            return parseFloat($(a).data(sortName)) - parseFloat($(b).data(sortName));
                        })
                    } else {
                        var sortedList = wrapper.find('[data-sortable]').sort(function (a, b) {
                            return parseFloat($(b).data(sortName)) - parseFloat($(a).data(sortName));
                        })
                    }

                    var first = true;
                    sortedList.each(function () {
                        if (first) {
                            $(this).find('.collapse').addClass('in');
                            first = false;
                        } else {
                            $(this).find('.collapse.in').removeClass('in');
                        }

                        wrapper.append($(this));
                    });
                });

                $('[data-sort-text]').html($(this).html());

                if (event.originalEvent !== undefined) {
                    let activePage = $('[data-set-active-page].pagination-number--active').length > 0 ? $('[data-set-active-page].pagination-number--active').data('setActivePage') : 0;
                    Helper.initSliderGallery(activePage + 1);
                }

                window.urlClass.addOrReplaceActiveParam({
                    sortName: sortName,
                    sortWay: sortWay
                }, 'masonrySort');

                $.ajax({
                    method: 'POST',
                    url: window.location.origin + "/filter/set-sort-session",
                    data: {
                        'sortName': sortName,
                        'sortWay': sortWay,
                        '_token': $('meta[name="csrf-token"]').attr('content')
                    }
                });
            });

            if ($('[data-masonrysort].active').length > 0) {
                $('[data-masonrysort].active').trigger('click');
            }
        });
    }
}
